import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CtaButton({
  children,
  onClick,
  className = ''
}: CtaButtonProps) {
  return <motion.button type="button" onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    scale: [1, 1.025, 1]
  }} transition={{
    duration: 2.2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`group relative flex w-full items-center justify-center gap-2 overflow-hidden rounded-2xl bg-magenta px-6 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(214,41,110,0.7)] sm:text-lg ${className}`} data-id="element-77" data-mp="cl2c3xggl3ib">
      <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:translate-x-full group-hover:transition-transform group-hover:duration-1000" data-id="element-78" data-mp="19c38yy2myl0k" />
      <span className="relative z-10" data-id="element-79" data-mp="35yz4gxhzzgc2">{children}</span>
      <ArrowRightIcon className="relative z-10 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-80" data-mp="39y7zs6sorm9q" />
    </motion.button>;
}